import axiosInstance from "./api_helper";

const endpoint = "/api/settings/system";
const listeners = new Set();
let snapshot = { droitTimbreEnabled: false, loaded: false, loading: false, error: null };
let pending;
const publish = (changes) => {
  snapshot = { ...snapshot, ...changes };
  listeners.forEach((listener) => listener());
};
const accept = (data) => {
  publish({ droitTimbreEnabled: data.droitTimbreEnabled !== false, loaded: true, loading: false, error: null });
  return snapshot;
};

const systemSettingsService = {
  subscribe: (listener) => { listeners.add(listener); return () => listeners.delete(listener); },
  getSnapshot: () => snapshot,
  load: () => {
    if (pending) return pending;
    publish({ loading: true, error: null });
    const request = axiosInstance.get(endpoint).then(({ data }) => accept(data)).catch((error) => {
      publish({ loading: false, error: "Impossible de charger les paramètres de vente." });
      throw error;
    }).finally(() => { if (pending === request) pending = null; });
    pending = request;
    return request;
  },
  save: (droitTimbreEnabled) => {
    const previous = pending;
    const write = async () => {
      // Serialize reads and writes so an old read cannot overwrite a saved setting.
      if (previous) await previous.catch(() => {});
      const { data } = await axiosInstance.put(endpoint, { droitTimbreEnabled });
      return accept(data);
    };
    const request = write().finally(() => { if (pending === request) pending = null; });
    pending = request;
    return request;
  },
};

export default systemSettingsService;
